import React from "react";
import { useIntl } from "react-intl";
import { Row, Col, Typography } from "antd";

const { Text, Title } = Typography;

const PartNumber = ({ index }) => (
  <Row type="flex" align="middle" justify="center">
    <Col>
      <Title level={4}>{index + 1}</Title>
    </Col>
  </Row>
);

const PaperPart = ({ full, index, onClick, className, selectedQuater }) => (
  <Col
    span={full ? 24 : 12}
    onClick={() => onClick(index)}
    className={`center paper-part ${className || ""} ${
      selectedQuater === index ? "paper-part-selected" : ""
    }`}
  >
    <PartNumber index={index} />
  </Col>
);

const PaperHalf = ({ first, second, onQuaterClick, selectedQuater }) => (
  <Row
    type="flex"
    justify="center"
    className={`paper-half ${first === 0 ? "paper-half-first" : ""}`}
  >
    <PaperPart
      index={first}
      onClick={onQuaterClick}
      className="paper-part-first"
      selectedQuater={selectedQuater}
    />
    <PaperPart
      index={second}
      onClick={onQuaterClick}
      selectedQuater={selectedQuater}
    />
  </Row>
);

function LabelPositionSelect({
  landscape,
  selectedPosition,
  onSelectedPosition,
}) {
  const intl = useIntl();
  return (
    <Row type="flex" justify="center">
      <Col span={20}>
        <Row gutter={[0, 20]}>
          <Col className="center">
            <Text level={5}>
              {intl.formatMessage({
                id: "consignment.print.labelPosition",
                defaultMessage: "Vyberte pozici prvního štítku",
              })}
            </Text>
          </Col>
        </Row>
        <Row type="flex" justify="center" gutter={[0, 20]}>
          <Col span={16}>
            {landscape ? (
              [...Array(3)].map((_, i) => (
                <PaperPart
                  full
                  key={i}
                  index={i}
                  onClick={onSelectedPosition}
                  selectedQuater={selectedPosition}
                  className={`paper-third ${i === 2 ? "paper-third-last" : ""}`}
                />
              ))
            ) : (
              <div>
                <PaperHalf
                  first={0}
                  second={1}
                  onQuaterClick={onSelectedPosition}
                  selectedQuater={selectedPosition}
                />
                <PaperHalf
                  first={2}
                  second={3}
                  onQuaterClick={onSelectedPosition}
                  selectedQuater={selectedPosition}
                />
              </div>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default LabelPositionSelect;
